module.exports = __webpack_public_path__ + "static/media/WoodSplit_Before.2d71b3cb.jpg";